/**
 * Module dependencies.
 */

import { Filters as AvailableFilters } from 'src/types/products';
import BaseFiltersSidebar from 'src/components/filters/filters-sidebar';
import ColorFilter from 'src/components/collections/filters-list/color-filter';
import FinishFilter from 'src/components/collections/filters-list/finish-filter';
import FormatFilter from 'src/components/collections/filters-list/format-filter';
import FunctionFilter from 'src/components/collections/filters-list/function-filter';
import React, { ReactElement } from 'react';
import ThicknessFilter from 'src/components/collections/filters-list/thickness-filter';
import TypologyFilter from 'src/components/collections/filters-list/typology-filter';
import size from 'lodash/size';

/**
 * `Props` type.
 */

type Props = {
  availableFiltersList: AvailableFilters;
  isOpen: boolean;
  isUpdating: boolean;
  onClose: () => void;
  onUpdate: () => void;
};

/**
 * `FiltersSidebar` component.
 */

const FiltersSidebar = (props: Props): ReactElement => {
  const { availableFiltersList, isOpen, isUpdating, onClose, onUpdate } = props;
  const { colors, finishes, formats, functions, thickness, typologies } = availableFiltersList;

  return (
    <BaseFiltersSidebar isOpen={isOpen} isUpdating={isUpdating} onClose={onClose} onUpdate={onUpdate}>
      {size(typologies) > 1 && <TypologyFilter filtersList={typologies} />}

      {size(functions) > 1 && <FunctionFilter filtersList={functions} />}

      {size(formats) > 1 && <FormatFilter filtersList={formats} />}

      {size(colors) > 1 && <ColorFilter filtersList={colors} />}

      {size(finishes) > 1 && <FinishFilter filtersList={finishes} />}

      {size(thickness) > 0 && <ThicknessFilter filtersList={thickness} />}
    </BaseFiltersSidebar>
  );
};

/**
 * Export `FiltersSidebar` component.
 */

export default FiltersSidebar;
